import {NgModule} from '@angular/core';
import {RouterModule} from '@angular/router';
import {ItemGridScrollPage} from './item-grid-scroll';
import {ItemRouteModule} from '../../routes/item/item.route';
import {SharedModule} from '../../shared/shared.module';
import {CategoryGuard} from '../../core/guards/category.guard';
import {ClearCartGuard} from 'src/app/core/guards/clear-cart.guard';
import {ComboModifier} from 'src/app/routes/item/combo-modifier.module';
import {AppItemModule} from '../../components/item/item.module';
import { GridLayoutItemModule } from '../../components/grid-layout-item/grid-layout-item.module';

import { VirtualScrollerModule } from 'ngx-virtual-scroller';
import { GridLayoutItemModuleDouble } from 'src/app/components/grid-layout-item-double/grid-layout-item-double.module';
const customDefaultOptions = {
    scrollThrottlingTime: 0, // 滚动时间 最好set0
    scrollDebounceTime: 0,  // 滚动最后衰减
    scrollAnimationTime: 0,
    checkResizeInterval: 0, // 检查item大小的频率
    resizeBypassRefreshThreshold: 5, // item相差多少px,可以不用refersh
    // modifyOverflowStyleOfParentScroll: true,
    // stripedTable: false,
};
@NgModule({
    declarations: [ItemGridScrollPage],
    imports: [
    SharedModule,
        ItemRouteModule,
        ComboModifier,
        AppItemModule,
        VirtualScrollerModule,
        GridLayoutItemModule,
        GridLayoutItemModuleDouble,
        RouterModule.forChild([
            {
                path: '',
                canActivate: [CategoryGuard],
                canDeactivate: [ClearCartGuard],
                component: ItemGridScrollPage
            },

        ])
    ],
    providers: [
        {
            provide: 'virtual-scroller-default-options', useValue: customDefaultOptions
        }
      ],
})
export class ItemGridScrollModule {
}
